// Shared desktop/web socket normalization for titles emitted as plain strings,
// JSON strings or structured model output. Keep this leaf usable by Windows
// without importing the shared socket manager and its platform stores.
function sanitizeSocketChatTitle(title, fallback = 'Untitled Chat') {
  if (!title) return fallback;
  if (typeof title === 'string') {
    const trimmed = title.trim();
    if (trimmed.startsWith('{') && trimmed.endsWith('}')) {
      try {
        const parsed = JSON.parse(trimmed);
        if (parsed.title && typeof parsed.title === 'string') return parsed.title.trim();
      } catch (_) { /* Plain text remains displayable. */ }
    }
    return title;
  }
  if (typeof title === 'object') {
    if (title.title && typeof title.title === 'string') return title.title.trim();
    const string = Object.values(title).find(value => typeof value === 'string');
    return string ? string.trim() : fallback;
  }
  return String(title);
}

module.exports = { sanitizeSocketChatTitle };
